import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { NzTreeNodeOptions } from 'ng-zorro-antd/tree';
import { NzTreeSelectComponent } from 'ng-zorro-antd/tree-select';

@Component({
  selector: 'app-input-tree-select',
  templateUrl: './input-tree-select.component.html',
  styleUrl: './input-tree-select.component.scss',
})
export class InputTreeSelectComponent {
  @Input() placeholder: string = 'Select options';
  @Input() label: string = '';
  @Input() type: string = 'text';
  @Input() isDisabled: boolean = false;
  @Input() control: FormControl = new FormControl();
  @Input() size: 'small' | 'default' | 'large' = 'default';
  @Input() showClear: boolean = false;
  @Input() nodes: NzTreeNodeOptions[] = [];
  @Input() expandKeys: any[] = [];
  @Output() selectionChange = new EventEmitter<any[]>();

  @ViewChild('tree') tree!: NzTreeSelectComponent;

  ngOnInit(): void {}

  isRequired(control: AbstractControl | null): boolean {
    if (!control || !control.validator) {
      return false;
    }
    const validator = control.validator({} as AbstractControl);
    return validator && validator['required'] ? true : false;
  }
}
